import React from "react";
import PropTypes from "prop-types";

import RetailPOSWorkspace
  from "./RetailPOSWorkspace";

import {
  useRetailPOSRuntime,
} from "./useRetailPOSRuntime";


/**
 * React boundary between global application providers and
 * the pure RetailPOSWorkspace.
 *
 * RetailPOSWorkspace itself remains free from Context imports.
 */
export default function RetailPOSWorkspaceRuntimeBoundary({
  productResolver = null,
  productSearchProvider = null,
  sessionBridge = null,

  customerRuntime = null,
  loyaltyRuntime = null,
  receiptRuntime = null,

  ...workspaceProps
}) {
  const runtime =
    useRetailPOSRuntime({
      productResolver,
      productSearchProvider,
      sessionBridge,
      customerRuntime,
      loyaltyRuntime,
      receiptRuntime,
    });

  return (
    <RetailPOSWorkspace
      {...workspaceProps}
      runtime={runtime}
    />
  );
}


RetailPOSWorkspaceRuntimeBoundary.propTypes = {
  productResolver:
    PropTypes.func,

  productSearchProvider:
    PropTypes.func,

  sessionBridge:
    PropTypes.object,

  customerRuntime:
    PropTypes.object,

  loyaltyRuntime:
    PropTypes.object,

  receiptRuntime:
    PropTypes.object,

  resolvedPOSActivityDomain:
    PropTypes.object,

  runtimeConfiguration:
    PropTypes.object,

  publication:
    PropTypes.object,

  workspaceDescriptor:
    PropTypes.object,

  navigation:
    PropTypes.array,

  actions:
    PropTypes.array,
};
